// extracted by mini-css-extract-plugin
export var icon = "_5r-1";
export var subtext = "_5r-0";